var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCollapseArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 20 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.1 0 10 8.1 1.9 0 0 1.9 8.1 10l1.9 1.9 1.9-1.9L20 1.9z"
})));
export default SvgCollapseArrow;